import React from 'react';
import PropTypes from 'prop-types';

// HELP
import SearchCardApp from './help/SearchCardApp';
import SearchCardChannel from './help/SearchCardChannel';
import SearchCardShowMovie from './help/SearchCardShowMovie';
import SearchCardContentCrew from './help/SearchCardContentCrew';

const SearchCardManager = props => {
  const { type } = props;

  let content = null;

  switch (type) {
    case 'app':
      content = <SearchCardApp {...props} />;
      break;
    case 'channel':
      content = <SearchCardChannel {...props} />;
      break;
    case 'movie':
    case 'show':
      content = <SearchCardShowMovie {...props} />;
      break;
    case 'content_crew':
      content = <SearchCardContentCrew {...props} />;
      break;

    default:
      break;
  }

  return content;
};

SearchCardManager.propTypes = {
  type: PropTypes.string.isRequired,
};

export default React.memo(SearchCardManager);
